import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import type { SupportedLocale } from '@/i18n';

/**
 * Locale for nav, footers, sidebars, and picking translated listing rows — follows
 * `vue-i18n` (including persisted preference on default-locale URLs).
 */
export function useUiDisplayLocale() {
  const { locale } = useI18n();
  return computed(() => locale.value as SupportedLocale);
}
